// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3gG3G","list":"BalanceDue_list__1Fw5v","listRow":"BalanceDue_listRow__11YMe","total":"BalanceDue_total__6nhg3"};